import { useQuery } from "@apollo/client/react";
import type { InvoiceModel } from "../../../models/InvoiceModels";
import GET_INVOICE_DELIVERY_APPROVALS from "../../queries/invoices/getInvoiceDeliveryApprovals";

export const useInvoiceDeliveryApprovals = (
  clientIdentifier?: string,
  invoiceId?: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    invoice: InvoiceModel;
  }>(GET_INVOICE_DELIVERY_APPROVALS, {
    skip: !clientIdentifier || !invoiceId,
    variables: {
      clientIdentifier: clientIdentifier,
      invoiceId: invoiceId,
    },
    errorPolicy: "all",
  });
  return { invoice: data?.invoice, error, loading, refetch };
};
